"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const scale_1 = require("../../../utils/scale");
const LINE_MARGIN_TOP = (0, scale_1.scale)(12);
const LINE_HEIGHT = (0, scale_1.moderateScale)(21);
const Hashtags = (props) => {
    const { title, hashtags } = props;
    const [hashtagList, setHashtagList] = (0, react_1.useState)([...hashtags].slice(0, 10));
    const [showMoreButtonVisible, setShowMoreButtonVisible] = (0, react_1.useState)(hashtags.length > 10);
    (0, react_1.useEffect)(() => {
        setHashtagList([...hashtags].slice(0, 10));
    }, [hashtags]);
    return (react_1.default.createElement(react_native_1.View, { style: { position: 'relative' } },
        !!title && (react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.title2 }, title)),
        react_1.default.createElement(react_native_1.View, { style: styles.hashTagList }, hashtagList.map((item, index) => (react_1.default.createElement(components_1.HashtagText, { key: index, text: item.name, style: styles.hashTag, onPress: () => {
                (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                    screen: Routes_1.default.HASHTAG_DETAIL,
                    params: {
                        hashtag: item.name,
                        typeScreen: 0,
                        typeHashTag: 4,
                    },
                });
            } })))),
        showMoreButtonVisible && (react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.hashTagMoreButton, onPress: () => {
                setHashtagList(hashtags);
                setShowMoreButtonVisible(false);
            } },
            react_1.default.createElement(CustomText_1.default, { style: styles.hashTagMoreLabel }, "\u3055\u3089\u306B\u8868\u793A"))),
        hashtagList?.length == 0 && (react_1.default.createElement(CustomText_1.default, { style: {
                marginTop: LINE_MARGIN_TOP,
                marginRight: (0, scale_1.scale)(12),
                fontSize: (0, scale_1.moderateScale)(14),
                lineHeight: LINE_HEIGHT,
            } }, "\u307E\u3060\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u30D5\u30A9\u30ED\u30FC\u3057\u3066\u3044\u307E\u305B\u3093\u3002"))));
};
const TabDashboard = (props) => {
    const { isActive, publicHashtags, privateHashtags, isMyProfile } = props;
    return (react_1.default.createElement(react_native_1.View, { style: [styles.container, !isActive && { display: 'none' }] },
        react_1.default.createElement(react_native_1.View, { style: styles.row },
            react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles.title, numberOfLines: 1 }, "\u30D5\u30A9\u30ED\u30FC\u3057\u3066\u3044\u308B\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0"),
            isMyProfile && (
            // <TouchableOpacity onPress={() => navigate(Routes.FOLLOW_TAG)}>
            //     <CustomText style={[styles.hashTag, { marginTop: 0, marginRight: 0 }]}>編集</CustomText>
            // </TouchableOpacity>
            react_1.default.createElement(components_1.LinkButton, { title: '\u7DE8\u96C6', textStyle: { fontSize: (0, scale_1.moderateScale)(14), lineHeight: (0, scale_1.moderateScale)(17) }, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.FOLLOW_TAG) }))),
        react_1.default.createElement(Hashtags, { title: isMyProfile ? '公開中のハッシュタグ' : '', hashtags: publicHashtags }),
        isMyProfile && (react_1.default.createElement(Hashtags, { title: '\u975E\u516C\u958B\u4E2D\u306E\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0', hashtags: privateHashtags }))));
};
exports.default = TabDashboard;
const styles = react_native_1.StyleSheet.create({
    row: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center'
    },
    container: {
        minHeight: scale_1.height * 0.7,
        paddingVertical: (0, scale_1.scale)(12),
        paddingHorizontal: (0, scale_1.scale)(16),
        marginBottom: (0, scale_1.scale)(40)
    },
    title: {
        flex: 1,
        fontSize: (0, scale_1.moderateScale)(18),
        lineHeight: (0, scale_1.moderateScale)(27),
        color: '#292A33'
    },
    title2: {
        marginTop: (0, scale_1.scale)(12),
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33'
    },
    invisibleView: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 0,
        opacity: 0,
    },
    hashTagList: {
        width: '100%',
        flexDirection: 'row',
        flexWrap: 'wrap',
        zIndex: 1,
        overflow: 'hidden'
    },
    hashTag: {
        marginTop: LINE_MARGIN_TOP,
        marginRight: (0, scale_1.scale)(12),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: LINE_HEIGHT,
        color: '#007AFF'
    },
    hashTagMoreButton: {
        marginTop: (0, scale_1.scale)(12),
        alignSelf: 'flex-start',
        zIndex: 1
    },
    hashTagMoreLabel: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#007AFF'
    }
});
